



































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { deleteCustomer, getCustomers } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import AuthModule from '../store/AuthModule';
import get from 'lodash/get';
import Customer from '../models/Customer';
import User from '../models/User';
import HeaderDatatable from '../models/HeaderDatatable';
import { fetchPrescriber } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import { customerTypes, formatCustomerTypes } from '@/data/customerTypes';
import { formatCustomerStatus } from '@/data/customerStatus';
import formatCustomer from '@/utils/formatCustomer';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

@Component({
    components: {
        FilterComponent,
        Datatable,
    },
    filters: {
        prescriberToString: function(prescriber: User) {
            return `${prescriber.lastname} ${prescriber.firstname}`;
        },
        formatCustomerTypes,
        formatCustomer,
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatCustomerStatus,
    },
})
export default class Customers extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescribers: undefined,
            type: undefined,
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Prospect Acquéreur',
            dataIndex: 'lastname',
            sorter: true,
            width: 200,
            scopedSlots: {
                customRender: 'lastname',
            },
        },
        {
            title: 'Type',
            dataIndex: 'type',
            sorter: true,
            width: 110,
            scopedSlots: {
                customRender: 'type',
            },
        },
        {
            title: 'Statut',
            dataIndex: 'status',
            width: 130,
            scopedSlots: {
                customRender: 'status',
            },
            sorter: true,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
            width: 200,
        },
        {
            title: 'Prescripteur',
            dataIndex: 'prescriber',
            sorter: true,
            width: 180,
            scopedSlots: {
                customRender: 'prescriber',
            },
        },
        {
            title: 'Ville prospect',
            dataIndex: 'address.city',
            sorter: true,
            width: 150,
        },
        {
            title: 'Date dénonce',
            dataIndex: 'denounces',
            width: 130,
            scopedSlots: {
                customRender: 'last_denounce_date',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            width: 100,
            scopedSlots: {
                customRender: 'actions',
            },
        },
    ];
    async fetch(meta: MetaDatatable) {
        const { data } = await getCustomers({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }
    deleteText = {
        confirm: {
            title: `Suppression de le client`,
            content: `Voulez-vous vraiment supprimer le client ?`,
        },
        notify: {
            title: 'Client supprimé',
            content: `Le client a bien été supprimé`,
        },
    };

    colorType(value: 'prospect' | 'customer'): string {
        // TODO : à voir pour les couleurs
        if (value === 'customer') {
            return 'success';
        }
        return 'primary';
    }

    get fetchPrescriber() {
        return fetchPrescriber;
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Customer | null;
    }) {
        const action = ev.action;
        const customer: Customer | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (customer !== null) {
                    this.$router.push({
                        name: 'editCustomer',
                        params: {
                            id: `${customer.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (customer && customer.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteCustomer(customer.id);
                }
                break;
        }
    }

    deleteDialog(customer: Customer) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(customer),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(customer: Customer) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: customer });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du client`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    get customerTypesArr() {
        return Object.keys(customerTypes).map(key => ({
            text: (customerTypes as any)[key],
            value: key,
        }));
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;
    typeModel: string | undefined | null = null;
    created() {
        this.typeModel = undefined;
        this.prescriberModel = undefined;
    }

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.type) {
            this.typeModel = this.meta.filters.type;
        } else {
            this.typeModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.prescribers) {
            this.prescriberModel = this.meta.filters.prescribers[0];
        } else {
            this.prescriberModel = undefined;
        }
    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters.prescribers = [this.prescriberModel];
        } else if (this.meta.filters) {
            this.meta.filters.prescribers = null;
        }
    }

    @Watch('typeModel', { immediate: true })
    onTypeModel() {
        if (this.typeModel) {
            this.meta.filters.type = this.typeModel;
        } else if (this.meta.filters) {
            this.meta.filters.type = null;
        }
    }
}
